import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=56c1a9d8&scoped=true&"
import script from "./contacts.vue?vue&type=script&lang=js&"
export * from "./contacts.vue?vue&type=script&lang=js&"
import style0 from "./contacts.vue?vue&type=style&index=0&id=56c1a9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c1a9d8",
  null
  
)

export default component.exports